import { Platform, StyleSheet } from 'react-native';
import NativeStorage from './implementations/NativeStorage';
import WebStorage from './implementations/WebStorage';
import { Storage } from './Storage';

const AppStorage = Storage.getInstance();

export default AppStorage;